import { Reveal, MaskedText } from "@/components/motion/Reveal";
import Reel from "@/components/Reel";
import { OpenableImage } from "@/components/MediaViewer";
import { BTS_REELS, BTS_STILLS } from "@/data/media";
import { LOCATION } from "@/data/content";

export default function Studio() {
  return (
    <>
      <section data-testid="studio-hero" className="px-6 pb-4 pt-36 md:px-12 md:pt-44">
        <div className="mx-auto max-w-[1400px]">
          <Reveal>
            <p className="overline mb-8 text-muted">(Studio)</p>
          </Reveal>
          <MaskedText
            lines={["Behind", "the Scenes"]}
            delay={0.1}
            className="font-display text-[11vw] font-extralight leading-[0.92] tracking-tight text-ink lg:text-[7vw]"
          />
          <Reveal delay={0.3}>
            <p className="mt-10 max-w-md font-body text-sm leading-relaxed text-stone">
              The good, the goofy and everything in between — from set and studio in{" "}
              {LOCATION}, this is how the work actually gets made. Tap any frame to pop it
              open in its own window.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="studio-reels" className="px-6 pb-8 pt-16 md:px-12 md:pb-12 md:pt-24">
        <Reveal className="mx-auto mb-10 max-w-[1400px] md:mb-14">
          <p className="overline text-muted">Moving Image</p>
        </Reveal>
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-6 md:grid-cols-2 md:gap-10">
          {BTS_REELS.map((r, i) => (
            <Reel
              key={r.id}
              {...r}
              index={i + 1}
              label="BTS"
              ratio="aspect-video"
              className={i % 2 === 1 ? "md:mt-16" : ""}
            />
          ))}
        </div>
      </section>

      <section data-testid="studio-stills" className="px-6 py-16 md:px-12 md:py-24">
        <Reveal className="mx-auto mb-10 max-w-[1400px] md:mb-14">
          <p className="overline text-muted">The Making</p>
        </Reveal>
        <div className="mx-auto max-w-[1400px] gap-4 md:gap-8 [column-count:2] lg:[column-count:3]">
          {BTS_STILLS.map((s) => (
            <Reveal key={s.src} className="mb-4 break-inside-avoid md:mb-8">
              <OpenableImage src={s.src} alt={s.alt} label="BTS" />
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
